export default function ShowPublication({ publication }: any) {
  return (
    <div className="h-screen flex items-center justify-center overflow-hidden">
      <h1 className="text-[320px] text-center font-medium mt-6 whitespace-nowrap">
        {publication.name}
      </h1>
    </div>
  );
}
